import React from "react";
import "../css/zoho/zohoProducts.css";

import useCountry from "../../Hooks/useCountry";
import products from "../../Data/zohoProducts";


const ZohoCards = () => {
    const country = useCountry() ?? "US";

    // console.log("Country code:", country);

    return (
        <main className="container py-3 zoho-main-css">
            <div className="row g-3 zoho-grid-css">
                {products.map((product, index) => (
                    <div className="col-12 col-md-6 col-lg-4 zoho-col-css" key={index}>
                        <article className="card h-100 shadow-sm zoho-card-css">
                            <div className="zoho-img-wrapper-css">
                                <img
                                    src={product.imgSrc}
                                    className="card-img-top zoho-img-css"
                                    alt={product.title}
                                />
                            </div>
                            <div className="card-body d-flex flex-column zoho-body-css p-3">
                                <h3 className="card-title h5 zoho-title-css">
                                    {product.title}
                                </h3>
                                <p className="card-text text-secondary flex-grow-1 zoho-desc-css">
                                    {product.description}
                                </p>
                                <div className="mt-auto border-top pt-2 zoho-action-css">
                                    {/* <button className="btn btn-primary w-100 py-1 fw-semibold zoho-btn-css">
                                        Try Now
                                    </button> */}
                                    <a
                                        href={country === "IN" ? product.indiaLink : product.usaLink}
                                        target="_blank"
                                        rel="noopener sponsored"
                                        className="btn btn-primary w-100 py-1 fw-semibold zoho-btn-css"
                                    >
                                        Try Now
                                    </a>
                                </div>
                            </div>
                        </article>
                    </div>
                ))}
            </div>
        </main>
    );
};

export default ZohoCards;